import { useTranslation } from '@/i18n/useTranslation';

import { Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';
import { RoleGuard } from './RoleGuard';
import { FullPageSpinner } from '@/components/common/FullPageSpinner';
import { ForbiddenPage } from '@/components/common/ForbiddenPage';

/**
 * Route wrapper for admin pages. User management has an additional super admin
 * guard. The backend independently enforces roles on admin and reference-data
 * write endpoints
 * — this is UX gating only (docs/RBAC.md).
 */
export function AdminRoute() {
  const { t } = useTranslation();
  const { role, isProfileLoading } = useAuth();

  return (
    <RoleGuard
      allowedRoles={['admin', 'super_admin']}
      userRole={role}
      isLoading={isProfileLoading}
      loadingFallback={<FullPageSpinner label={t('Checking permissions…')} />}
      forbiddenFallback={<ForbiddenPage />}
    >
      <Outlet />
    </RoleGuard>
  );
}
